import type { PlanType } from "~/interface/organization";

export const planMap: {
  [planType in PlanType]: {
    name: string;
  };
} = {
  free: {
    name: "フリープラン",
  },
  starter: {
    name: "スタータープラン",
  },
  standard: {
    name: "スタンダードプラン",
  },
  professional: {
    name: "プロフェッショナルプラン",
  },
  enterprise: {
    name: "エンタープライズプラン",
  },
};
